import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col fd-noise">
      <Header />
      <main className="flex-1 relative z-[2]">{children}</main>
      <Footer />
    </div>
  );
}
